import { useQuery } from '@tanstack/react-query';
import { timeAttendanceService } from '@/services/timeAttendance';
import { timeAttendanceKeys } from './queryKeys';

export const useCurrentTimeEntry = (profileId: string | undefined) => {
  return useQuery({
    queryKey: timeAttendanceKeys.currentEntry(profileId || ''),
    queryFn: () => timeAttendanceService.getCurrentTimeEntry(profileId!),
    enabled: !!profileId,
    staleTime: 30 * 1000, // 30 seconds
    refetchInterval: 3 * 60 * 60 * 1000, // 3 hours - reduced polling to save costs (mutations still invalidate immediately)
    refetchOnWindowFocus: true,
  });
};
